/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Video_Audio_Extraction_FailedInputs */



/**
* | output |
* | --- |
* | "Could not extract audio from \"{name}\". The video format may not be supported by your browser." |
*
* @param {Video_Audio_Extraction_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const video_audio_extraction_failed = /** @type {((inputs: Video_Audio_Extraction_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Audio_Extraction_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Audio konnte nicht aus "${i?.name}" extrahiert werden. Das Videoformat wird möglicherweise von deinem Browser nicht unterstützt.`)
	return /** @type {LocalizedString} */ (`Could not extract audio from "${i?.name}". The video format may not be supported by your browser.`)
});